import { meterOpenFormModalConfig } from '@shared/modals/meter/meter-openform/meter-openform.modal-config';
import { ModalConfig } from '@shared/interfaces/modal/modal-config';

export const meterOpenformEditModalConfig: ModalConfig = {
  ...meterOpenFormModalConfig,
  title: 'meterFrame.actions.editMeter',
  actions: [
    {
      type: 'primary',
      label: 'system.button.save',
      method: 'saveChanges'
    },
    {
      type: 'secondary',
      label: 'system.button.cancel',
      closeOnClick: true
    },
  ],

}
